import React, { useState, useEffect, useContext, createContext } from "react";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import firebase_app from "../firebase/config";
import logout from "../firebase/auth/logout"; // Assuming this handles Firebase logout

const auth = getAuth(firebase_app);
const db = getFirestore(firebase_app);

const AuthContext = createContext();

export const useAuthContext = () => useContext(AuthContext);

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // Attempt to fetch user data from the 'telegramUsers' collection
        // to ensure we get the comprehensive user profile that includes game data.
        const userDoc = await getDoc(doc(db, "telegramUsers", firebaseUser.uid)); // <-- CHANGED: From "users" to "telegramUsers"
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          // Combine Firebase Auth user data with Firestore user data
          setUser({ ...firebaseUser, ...userData });
          setRole(userData.role || ''); // Set the role from Firestore data
        } else {
          // If no document in 'telegramUsers', use basic Firebase Auth user data
          // and set a default role or no role.
          console.warn(`User document for UID ${firebaseUser.uid} not found in 'telegramUsers' collection.`);
          setUser(firebaseUser);
          setRole(''); // Default role or empty if user document does not exist
        }
      } else {
        setUser(null);
        setRole(''); // Reset role when no user is authenticated
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []); // Dependencies: empty array, runs once on mount

  return (
    <AuthContext.Provider value={{ user, loading, role, logout }}>
      {children}
    </AuthContext.Provider>
  );
};